import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { TypedMemo } from '../../../../common/types';

interface FinishSetupRowLinkProps {
  /** The router path of the step (`catalogAddSongPath`, no `/app`). */
  path: string;
  className?: string;
  ariaLabel: string;
  children: React.ReactNode;
}

/**
 * The row link of a draft: it opens the next step of the "Add a song" page. A plain click stays in
 * the app; a click with a modifier key (a new tab) and a middle click use the real address.
 */
const FinishSetupRowLinkComponent: React.FC<FinishSetupRowLinkProps> = ({ path, className, ariaLabel, children }) => {
  const navigate = useNavigate();
  const onClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      event.preventDefault();
      // eslint-disable-next-line no-void
      void navigate(path);
    },
    [navigate, path]
  );

  return (
    <a href={`/app${path}`} className={className} aria-label={ariaLabel} onClick={onClick}>
      {children}
    </a>
  );
};

export const FinishSetupRowLink = TypedMemo(FinishSetupRowLinkComponent);
